import React from "react";
import styles from "./MadeToMeasureReviewModal.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import {
  MadeToMeasureConfiguration,
  RomanBlindConfiguration,
} from "../../configurationTypes";

type Props = {
  configuration: MadeToMeasureConfiguration;
  onClose: (e: React.SyntheticEvent) => void;
};

const RomanBlindsSelection = ({ configuration, onClose }: Props) => {
  const config = configuration as RomanBlindConfiguration;
  return (
    <>
      <li data-testid="m2m-review-config-window-fitting">
        <img
          className={styles.ReviewContent__image}
          src={`https://static.johnlewiscontent.com/v1/static/roman-stacking-${config.stackingStyle === "Standard" ? "standard" : "waterfall"}`}
          aria-label={`Stacking Style ${config.stackingStyle}`}
        />
        <div>
          <p className={styles.ReviewContent__title}>Stacking Style</p>
          <h2 data-testid="m2m-review-config-stacking-style">
            {config.stackingStyle}{" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-roman-blinds-stacking-style"
            >
              edit
            </UnderlinedButton>
          </h2>
          <p className={styles.ReviewContent__title}>Chain side</p>
          <h2 data-testid="m2m-review-config-control-side">
            {config.controlSide}{" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-roman-blinds-stacking-style"
            >
              edit
            </UnderlinedButton>
          </h2>
          <p className={styles.ReviewContent__title}>Measurements</p>
          <h2 data-testid="m2m-review-config-measurements">
            {config.width}cm (w) x {config.height}cm (h){" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-roman-blinds-measurements"
            >
              edit
            </UnderlinedButton>
          </h2>
          <p className={styles.ReviewContent__title}>Installation height</p>
          <h2 data-testid="m2m-review-config-installation-height">
            {config.installationHeight}cm{" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-roman-blinds-measurements"
            >
              edit
            </UnderlinedButton>
          </h2>
        </div>
      </li>
      <li>
        <img
          className={styles.ReviewContent__image}
          src={`https://static.johnlewiscontent.com/v1/static/lining-colour-${config.liningColour === "Cream" ? "cream" : "white"}`}
          aria-label={`Lining Colour ${config.liningColour}`}
        />
        <div>
          <p className={styles.ReviewContent__title}>Lining Options</p>
          <h2 data-testid="m2m-review-config-lining-weight">
            {config.liningWeight === "Blackout"
              ? "Premium Thermal Blackout Lining"
              : "Premium Cotton Lining"}{" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-roman-blinds-lining-options"
            >
              edit
            </UnderlinedButton>
          </h2>
          <p className={styles.ReviewContent__title}>Lining Colour</p>
          <h2 data-testid="m2m-review-config-lining-colour">
            {config.liningColour}{" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-roman-blinds-lining-options"
            >
              edit
            </UnderlinedButton>
          </h2>
        </div>
      </li>
      <li data-testid="m2m-review-config-safety-info">
        <p>
          Your custom roman blind will be operated using a child-safe*,
          break-away side chain mechanism in chain colour{" "}
          <strong>Chrome</strong>.
        </p>
        <p>* Complies with EU child safety regulations</p>
      </li>
    </>
  );
};

export default RomanBlindsSelection;
